import { IMAGE_UPLOAD, GIF_UPLOAD, VIDEO_UPLOAD, YOUTUBE_URL } from "./types";
export const SectorOptions = [
  { value: "Arts", label: "Arts" },
  { value: "Accounting", label: "Accounting" },
  { value: "Banking", label: "Banking" },
  { value: "Beauty", label: "Beauty" },
  { value: "Charity", label: "Charity" },
  { value: "Energy and utilities", label: "Energy and utilities" },
  { value: "Fashion", label: "Fashion" },
  { value: "Gyms", label: "Gyms" },
  { value: "Health", label: "Health" },
  { value: "Hospitality", label: "Hospitality" },
  { value: "Insurance", label: "Insurance" },
  { value: "Law", label: "Law" },
  { value: "Music", label: "Music" },
  { value: "Property", label: "Property" },
  { value: "Recruitment", label: "Recruitment" },
  { value: "Retail", label: "Retail" },
  { value: "Sports", label: "Sports" },
  { value: "Telecommunications", label: "Telecommunications" },
  { value: "Travel", label: "Travel" },
  { value: "Wellness and wellbeing", label: "Wellness and wellbeing" },
];

export const StageOptions = [
  {
    value: "Introduction",
    label: "Introduction",
  },
  {
    value: "Explore",
    label: "Explore",
  },
  {
    value: "Decision & Commercials",
    label: "Decision & Commercials",
  },
  {
    value: "Test Roll Out",
    label: "Test Roll Out",
  },
  {
    value: "Full Roll Out",
    label: "Full Roll Out",
  },
  {
    value: "Pro Roll Out",
    label: "Pro Roll Out",
  },
];

export const SalesManagerOptions = [
  {
    value: "Anthony",
    label: "Anthony",
  },
  {
    value: "Christopher",
    label: "Christopher",
  },
  {
    value: "Mark",
    label: "Mark",
  },
  {
    value: "Nidhi",
    label: "Nidhi",
  },
];

export const CampaignManagerOptions = [
  {
    value: "Amelia",
    label: "Amelia",
  },
];
export const TerritoryOptions = [
  {
    value: "UK",
    label: "UK",
  },
  {
    value: "USA",
    label: "USA",
  },
  {
    value: "Canada",
    label: "Canada",
  },
  {
    value: "Ireland",
    label: "Ireland",
  },
  {
    value: "Australia",
    label: "Australia",
  },
  {
    value: "France",
    label: "France",
  },
  {
    value: "India",
    label: "India",
  },
  {
    value: "German",
    label: "German",
  },
  {
    value: "SouthAfrica",
    label: "SouthAfrica",
  },
];
export const stageOptions = [
  {
    value: "Test Roll Out",
    label: "Test Roll Out",
  },
  {
    value: "Full Roll Out",
    label: "Full Roll Out",
  },
];
export const iconStyleOptions = [
  {
    value: "white",
    label: "White",
  },
  {
    value: "black",
    label: "Black",
  },
];
export const Characters = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
];

export const LayerTypes = [
  {
    value: "Statement",
    label: "Statement",
  },
  {
    value: "Statement agreeableness",
    label: "Statement agreeableness",
  },
  {
    value: "Polls",
    label: "Polls",
  },
  {
    value: "Question",
    label: "Question",
  },
  { value: "Age/DOB", label: "Age/DOB" },
  { value: "Calendar/Booking", label: "Calendar/Booking" },
  { value: "Address", label: "Address" },
  { value: IMAGE_UPLOAD, label: "Upload Image" },
  { value: GIF_UPLOAD, label: "Upload Gif" },
  { value: VIDEO_UPLOAD, label: "Upload Video" },
  { value: YOUTUBE_URL, label: "Link Video" },
];



// WEBPACK FOOTER //
// ./src/Constants/brand.js